/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Copy_TimecodesInputs */



/**
* | output |
* | --- |
* | "Copy timecodes" |
*
* @param {Copy_TimecodesInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const copy_timecodes = /** @type {((inputs?: Copy_TimecodesInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Copy_TimecodesInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Copier les timecodes")
	if (locale === "de") return /** @type {LocalizedString} */ ("Zeitcodes kopieren")
	if (locale === "it") return /** @type {LocalizedString} */ ("Copia i codici temporali")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Скопировать временные метки")
	if (locale === "es") return /** @type {LocalizedString} */ ("Copiar códigos de tiempo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("复制时间码")
	if (locale === "ja") return /** @type {LocalizedString} */ ("タイムコードをコピー")
	if (locale === "hi") return /** @type {LocalizedString} */ ("टाइमकोड कॉपी करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Copiar códigos de tempo")
	return /** @type {LocalizedString} */ ("Copy timecodes")
});